module.exports = __webpack_public_path__ + "static/media/Sainik_Khaddar_Resume.a6dea1bd.pdf";